var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02602 11.6771H12.9856C14.1339 11.6771 15.0682 10.7427 15.0682 9.59391V2.69254C15.0682 1.54375 14.1339 0.609375 12.9856 0.609375H3.02602C1.87774 0.609375 0.943359 1.54375 0.943359 2.69254V9.59391C0.943359 10.7427 1.87774 11.6771 3.02602 11.6771ZM1.85792 2.69254C1.85792 2.04828 2.38227 1.52444 3.02602 1.52444H12.9856C13.6298 1.52444 14.1537 2.04828 14.1537 2.69254V9.59391C14.1537 10.2382 13.6293 10.762 12.9856 10.762H3.02602C2.38176 10.762 1.85792 10.2382 1.85792 9.59391V2.69254Z",
    fill: "#737373",
    stroke: "#F8F8F8",
    strokeWidth: 0.255426
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66814 8.70098C6.87849 8.80972 7.10611 8.86357 7.33323 8.86357C7.62589 8.86357 7.91652 8.77415 8.16599 8.59835L9.97123 7.32203C10.3538 7.05173 10.582 6.61071 10.582 6.14225C10.582 5.6743 10.3533 5.23328 9.97123 4.96348L8.16548 3.68767C7.72242 3.37469 7.14879 3.33506 6.66763 3.58504C6.18647 3.834 5.88721 4.32583 5.88721 4.86745V7.41857C5.88772 7.96019 6.18647 8.45202 6.66814 8.70098ZM6.80228 4.86745C6.80228 4.66574 6.90897 4.48994 7.08833 4.39696C7.16658 4.35631 7.25041 4.33599 7.33323 4.33599C7.43942 4.33599 7.5451 4.36902 7.63757 4.43456L9.44281 5.71037C9.58508 5.81047 9.66637 5.96848 9.66637 6.14276C9.66637 6.31703 9.58457 6.47454 9.44231 6.57565L7.63707 7.85146C7.47245 7.96781 7.26769 7.98204 7.08782 7.88906C6.90847 7.79608 6.80177 7.62079 6.80177 7.41857L6.80228 4.86745Z",
    fill: "#737373",
    stroke: "#F8F8F8",
    strokeWidth: 0.255426
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryVideo);
export default __webpack_public_path__ + "static/media/CategoryVideo.95c4f8130c1eb2691222be649ab01bce.svg";
export { ForwardRef as ReactComponent };